<template>
  <div class="container py-5" style="max-width: 700px">
    <h2 class="mb-4">Publicar Nova Vaga</h2>

    <form @submit.prevent="salvarVaga">
      <div class="mb-3">
        <label for="titulo" class="form-label">Título da Vaga</label>
        <input
          type="text"
          v-model="vaga.titulo"
          class="form-control"
          id="titulo"
          required
        />
      </div>

      <div class="mb-3">
        <label class="form-label">Detalhes da Vaga</label>
        <textarea v-model="vaga.detalhes" class="form-control" rows="3" required></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">Requisitos</label>
        <textarea v-model="vaga.requisitos" class="form-control" rows="3" required></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">Local de Trabalho</label>
        <input type="text" v-model="vaga.local" class="form-control" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Unidade Cultural / Núcleo</label>
        <input type="text" v-model="vaga.nucleo_regional" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Formato</label>
        <select v-model="vaga.formato" class="form-select" required>
          <option disabled value="">Selecione</option>
          <option>Presencial</option>
          <option>Híbrido</option>
          <option>Remoto</option>
        </select>
      </div>

      <div class="mb-3">
        <label class="form-label">Modalidade de Contratação</label>
        <input type="text" v-model="vaga.modalidade" class="form-control" required />
      </div>
         <div class="mb-3">
        <label class="form-label">Jornada</label>
        <input type="text" v-model="vaga.jornada" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Faixa Salarial</label>
        <input type="text" v-model="vaga.salario" class="form-control" />
      </div>

      <div class="mb-3">
        <label class="form-label">Prazo para Candidatura</label>
        <input type="date" v-model="prazo" class="form-control" required />
      </div>

      <div class="mb-3">
        <label class="form-label">Status</label>
        <select v-model="vaga.status" class="form-select" required>
          <option value="aberta">aberta</option>
          <option value="encerrada">encerrada</option>
          <option value="cancelada">cancelada</option>
        </select>
      </div>

      <button type="submit" class="btn btn-success w-100">Salvar Vaga</button>
    </form>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: "NovaVagaVie",
  data() {
    return {
      vaga: {
        titulo: "",
        detalhes: "",
        requisitos: "",
        local: "",
        jornada: "",
        nucleo_regional: "",
        formato: "",
        modalidade: "",
        salario: "",
        statuss: "aberta",
      },
       prazo: ""
    };
  },
  methods: {
    async salvarVaga() {
    

      try {
        await api.post('cadastrar_vaga.php', {
          titulo: this.vaga.titulo,
          local: this.vaga.local,
          descricao: this.vaga.detalhes,
          jornada: this.vaga.jornada,
          requisitos: this.vaga.requisitos,
          formato: this.vaga.formato,
          modalidade: this.vaga.modalidade,
          salario: this.vaga.salario,
          nucleo_regional: this.vaga.nucleo_regional,
          statuss: this.vaga.statuss,
          prazo: this.prazo,
        });

        alert('Vaga publicada com sucesso!');
        this.$router.push('/admin');
      } catch (error) {
        alert(error.response?.data?.erro || 'Erro ao salvar vaga.');
      }
    },
    formatarDataBrasileira(dataISO) {
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}/${ano}`;
},

  },
};
</script>
